<template lang="pug">
  div
    el-row.labelStyle
      el-col(:span="12")
        app-display(label="Tipo Documento Legal:" :content="dadosJson.atosLegais.tipoDocumentoLegal || '-'")
        app-display(label="Instrumento Publicação:" :content="dadosJson.atosLegais.instrumentoPublicacao || '-'")
        app-display(label="UF:" :content="dadosJson.contato.estado || '-'")
        app-display(label="Município:" :content="dadosJson.atosLegais.municipio.id || '-'")
        app-display(label="Número Documento:" :content="dadosJson.atosLegais.numeroDocumento || '-'")
        app-display(label="Data Documento:" :content="formatData(dadosJson.atosLegais.dataDocumento) || '-'")
        app-display(label="Data Publicação:" :content="formatData(dadosJson.atosLegais.dataPublicacao) || '-'")
        app-display(label="Área em Hectares:" :content="dadosJson.atosLegais.areaHectares || '-'")
        app-display(label="Link Ato Legal:" :content="dadosJson.atosLegais.linkAtoLegal || '-'")
        app-display(label="Existe Ato Legal ou Complementar:" :content="dadosJson.atosLegais.existeAtoLegalOuComplementar || '-'")
        app-display(label="Plano Manejo Aprovado:" :content="dadosJson.atosLegais.planoManejoAprovado || '-'")
        app-display(label="Plano Manejo Tipo Documento:" :content="dadosJson.atosLegais.tipoDocumentoLegal || '-'")
        app-display(label="Instrumento Publicação Plano Manejo:" :content="dadosJson.atosLegais.instrumentoPublicacao || '-'")
        app-display(label="UF Plano Manejo:" :content="dadosJson.contato.estado || '-'")
        app-display(label="Município Plano Manejo:" :content="dadosJson.atosLegais.municipioPlanoManejo.id || '-'")
        app-display(label="Número Documento Plano:" :content="dadosJson.atosLegais.numeroDocumento || '-'")
        app-display(label="Data Documento Plano:" :content="formatData(dadosJson.atosLegais.dataDocumento) || '-'")
        app-display(label="Data Publicação Plano:" :content="formatData(dadosJson.atosLegais.dataPublicacao) || '-'")
        app-display(label="Link Plano Manejo:" :content="dadosJson.atosLegais.linkPlanoManejo || '-'")
        app-display(label="Link Plano Manejo Ato Legal:" :content="dadosJson.atosLegais.linkPlanoManejoAtoLegal || '-'")
      el-col(:span="12")
        app-display(label="Documento Conselho:" :content="dadosJson.atosLegais.documentoConselho || '-'")
        app-display(label="Tipo Documento Legal Conselho:" :content="dadosJson.atosLegais.tipoDocumentoLegalConselho || '-'")
        app-display(label="Instrumento Publicação Conselho:" :content="dadosJson.atosLegais.instrumentoPublicacaoConselho || '-'")
        app-display(label="UF Conselho:" :content="dadosJson.contato.estado || '-'")
        app-display(label="Município Conselho:" :content="dadosJson.atosLegais.municipioConselho.id || '-'")
        app-display(label="Número Documento Conselho:" :content="dadosJson.atosLegais.numeroDocumentoConselho || '-'")
        app-display(label="Data Documento Conselho:" :content="formatData(dadosJson.atosLegais.dataDocumentoConselho) || '-'")
        app-display(label="Data Publicação Conselho:" :content="formatData(dadosJson.atosLegais.dataPublicacaoConselho) || '-'")
        app-display(label="Link Plano Manejo Conselho:" :content="dadosJson.atosLegais.linkPlanoManejoConselho || '-'")
        app-display(label="Outros Instrumentos:" :content="dadosJson.atosLegais.outrosInstrumentos || '-'")
        app-display(label="Outros Instrumentos Tipo Documento:" :content="dadosJson.atosLegais.outrosInstrumentosTipoDocumento || '-'")
        app-display(label="Gestão Instrumento Publicação:" :content="dadosJson.atosLegais.gestaoInstrumentoPublicacao || '-'")
        app-display(label="UF Gestão:" :content="dadosJson.contato.estado || '-'")
        app-display(label="Município Gestão:" :content="dadosJson.atosLegais.municipioGestao.id || '-'")
        app-display(label="Número Documento Plano Gestão:" :content="dadosJson.atosLegais.numeroDocumentoPlanoGestao || '-'")
        app-display(label="Data Documento Plano Gestão:" :content="formatData(dadosJson.atosLegais.dataDocumentoPlanoGestao) || '-'")
        app-display(label="Data Publicação Gestão:" :content="formatData(dadosJson.atosLegais.dataPublicacaoGestao) || '-'")
        app-display(label="Link Plano Manejo Gestão Ato Legal:" :content="dadosJson.atosLegais.linkPlanoManejoGestaoAtoLegal || '-'")
        app-display(label="Link Plano Manejo Gestão:" :content="dadosJson.atosLegais.linkPlanoManejoGestao || '-'")
        app-display(label="Tipo Documento Legal Gestão:" :content="dadosJson.atosLegais.tipoDocumentoLegalGestao || '-'")
    listagem-documentos(
      v-if="documentosAtosLegais"
      :documentos="documentosAtosLegais",
      :protocoloCadastroOriginal="dadosJson.protocolo"
      ownerDocumento="ATOS_LEGAIS"
      :compararDocumentos="null"
      :versaoCadastro = "null"
    )
</template>

<script>
import AppDivider from '../AppDivider'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'
import moment from 'moment'
import ListagemDocumentos from '../informacoesCadastro/ListagemDocumentos'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: false
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple,
    ListagemDocumentos
  },

  computed: {
    documentosAtosLegais () {
      const docs = [
        this.dadosJson.atosLegais.anexoAtoLegal,
        this.dadosJson.atosLegais.anexoPlanoManejoAtoLegal,
        this.dadosJson.atosLegais.anexoPlanoManejo,
        this.dadosJson.atosLegais.anexoDocumentoConselho,
        this.dadosJson.atosLegais.anexoInstrumentoGestao,
        this.dadosJson.atosLegais.anexoInstrumentoGestaoAtoLegal
      ]
      return docs.filter(d => d)
    }
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
        } else {
          return telefone
        }
      })
    },

    formatData (data) {
      return moment(data).format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/AtosLegaisUc.vue